import {
  Box,
  Checkbox,
  Divider,
  Drawer,
  FormControlLabel,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { useSettingsContext } from './useSettingsContext.hook';
import { SettingsContextType } from './SettingsContext';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { ChangeEvent } from 'react';
import { HeaderAccentStyleKey } from './SettingsContext';
import { useMobile } from '@act/utilities/mobile-context';

interface SettingsDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const SettingsDrawer = ({ open, onClose }: SettingsDrawerProps) => {
  const { isMobile } = useMobile();
  const {
    themeKey,
    setThemeKey,
    headerAccentStyleKey,
    setHeaderAccentStyleKey,
    isHeaderAccentAnimationEnabled,
    setIsHeaderAccentAnimationEnabled,
  } = useSettingsContext();

  const handleThemeChange = (e: SelectChangeEvent<string>) => {
    setThemeKey(e.target.value as SettingsContextType['themeKey']);
  };

  const handleHeaderAccentChange = (e: SelectChangeEvent<string>) => {
    setHeaderAccentStyleKey(e.target.value as HeaderAccentStyleKey);
  };

  const handleHeaderAccentAnimationChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    setIsHeaderAccentAnimationEnabled(e.target.checked);
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      PaperProps={{
        sx: {
          width: isMobile ? '100%' : '30%',
          padding: '24px',
          boxSizing: 'border-box',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '24px',
        }}
      >
        <Typography variant="headlineMedium">Settings</Typography>
        <IconButton onClick={onClose} sx={{ marginLeft: 'auto' }}>
          <CloseOutlinedIcon />
        </IconButton>
      </Box>
      <Divider sx={{ margin: '24px 0' }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <Box>
          <Typography
            component="div"
            variant="titleMedium"
            sx={{ marginBottom: '8px' }}
          >
            Theme (Coming Soon)
          </Typography>
          <Select
            value={themeKey}
            onChange={handleThemeChange}
            fullWidth
            disabled={true}
          >
            <MenuItem value="LIGHT_MODE">Light mode</MenuItem>
            <MenuItem value="DARK_MODE">Dark mode</MenuItem>
            <MenuItem value="COLOR_BLIND_MODE">Colorblind mode</MenuItem>
          </Select>
        </Box>
        <Box>
          <Typography
            component="div"
            variant="titleMedium"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            Header Accent
            <FormControlLabel
              control={
                <Checkbox
                  checked={isHeaderAccentAnimationEnabled}
                  value={isHeaderAccentAnimationEnabled}
                  onChange={handleHeaderAccentAnimationChange}
                />
              }
              label="Show animation"
              sx={{ marginLeft: 'auto' }}
            />
          </Typography>
          <Select
            value={headerAccentStyleKey}
            onChange={handleHeaderAccentChange}
            fullWidth
          >
            <MenuItem value="none">None</MenuItem>
            <MenuItem value="rainbow">Rainbow</MenuItem>
            <MenuItem value="timberwolves">Timberwolves</MenuItem>
            <MenuItem value="vikings">Vikings</MenuItem>
          </Select>
        </Box>
      </Box>
    </Drawer>
  );
};
